import { Stack } from "@mui/material";
import { QuestionnairesList } from "./QuestionnairesList";
import { QuestionnaireForm } from "./QuestionnaireForm";
import { useQuestionnairesTab } from "../../../../hooks/useQuestionnairesTab";

export function QuestionnairesTab({
  setSelectedQuestionnaireId,
}: {
  setSelectedQuestionnaireId: (questionnaireId: string) => void;
}) {
  const {
    questionnaires,
    loading,
    error,
    selectedQuestionnaire,
    showHistory,
    historyQuestionnaireId,
    questionnaireResponses,
    patientId,
    encounterId,

    handleViewHistory,
    handleBackFromHistory,
    handleQuestionnaireSubmit,
    handleSelectQuestionnaire,
    handleBackFromForm,
    fetchResponses,
  } = useQuestionnairesTab();

  return (
    <Stack height="54vh">
      {!selectedQuestionnaire ? (
        <QuestionnairesList
          questionnaires={questionnaires}
          loading={loading}
          error={error}
          onSelect={(questionnaire) => {
            handleSelectQuestionnaire(questionnaire);
            setSelectedQuestionnaireId(questionnaire.id);
          }}
          onViewHistory={handleViewHistory}
          questionnaireResponses={questionnaireResponses}
        />
      ) : (
        <QuestionnaireForm
          questionnaire={selectedQuestionnaire}
          onBack={handleBackFromForm}
          onSubmit={handleQuestionnaireSubmit}
          onRefresh={fetchResponses}
          loading={false}
          patientId={patientId}
          encounterId={encounterId}
        />
      )}
    </Stack>
  );
}
